"use strict";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleLocalhost = exports.signOut = exports.openAccountSettings = exports.openPersonalInformation = exports.makeRedirect = exports.handleRedirect = exports.authStatus = exports.signIn = void 0;
const auth_1 = require("../build-babel/auth");
const cookieBanner_1 = require("../build-babel/cookieBanner");
const config_1 = __importDefault(require("../build-babel/auth/client/config"));
require("../build-babel/css/azure-common.css");
require("../build-babel/css/azure-template.css");
require("../build-babel/css/azure-forms.css");
require("../build-babel/css/azure-forms-forgot-password.css");
require("../build-babel/form");
const redirect_1 = require("../build-babel/redirect");
const redirect_2 = require("../build-babel/redirect/redirect");
const session_1 = require("../build-babel/session");
const localhost_1 = require("../build-babel/redirect/localhost");
const aem_1 = require("../build-babel/aem");
const status_1 = require("../build-babel/auth/status");
const envDetector_1 = require("../build-babel/utils/envDetector");
const error_1 = require("../build-babel/logger/error");
const signIn = () => __awaiter(void 0, void 0, void 0, function* () {
  (0, error_1.addErrorLogger)();
  if ((0, cookieBanner_1.shouldAddCookieConsentBanner)()) {
    (0, cookieBanner_1.addCookieConsentBanner)();
  }
  (0, redirect_1.setRedirectUrl)();
  yield (0, auth_1.redirectToLogin)();
});
exports.signIn = signIn;
// might be injected as iFrame that posts login status to the parent via postMessage
const authStatus = () => __awaiter(void 0, void 0, void 0, function* () {
  // sent current status
  const authStatus = yield (0, auth_1.getCurrentAuthStatus)();
  (0, status_1.onLoginStatusChange)(authStatus);
  // observe status change
  yield (0, auth_1.observeAuthStatus)(status_1.onLoginStatusChange);
});
exports.authStatus = authStatus;
const handleRedirect = () => __awaiter(void 0, void 0, void 0, function* () {
  const redirectUrl = (0, redirect_1.getRedirectUrlParam)();
  if (redirectUrl) {
    (0, redirect_2.makeRedirectTo)(redirectUrl);
  } else {
    yield (0, auth_1.redirectToLogin)();
  }
});
exports.handleRedirect = handleRedirect;
const makeRedirect = () => {
  const redirectUrl = (0, redirect_1.getRedirectUrl)();
  if (redirectUrl) {
    (0, redirect_2.makeRedirectTo)(redirectUrl);
  } else {
    const envConfig = (0, config_1.default)();
    if (envConfig) {
      (0, redirect_2.makeRedirectTo)(envConfig.homepageUri);
    }
  }
};
exports.makeRedirect = makeRedirect;
const openPersonalInformation = () => __awaiter(void 0, void 0, void 0, function* () {
  const envConfig = (0, config_1.default)();
  if (envConfig) {
    yield (0, auth_1.redirectToAuthority)(envConfig.authorities.editProfile);
  }
});
exports.openPersonalInformation = openPersonalInformation;
const openAccountSettings = () => __awaiter(void 0, void 0, void 0, function* () {
  const envConfig = (0, config_1.default)();
  if (envConfig) {
    yield (0, auth_1.redirectToAuthority)(envConfig.authorities.changePassword);
  }
});
exports.openAccountSettings = openAccountSettings;
const signOut = () => __awaiter(void 0, void 0, void 0, function* () {
  (0, session_1.removeSession)(window.location.href);
  const envConfig = (0, config_1.default)();
  if (envConfig) {
    const env = (0, envDetector_1.getEnv)(window.location.href);
    if (env) {
      yield (0, aem_1.logoutFromAEM)(envConfig.aem.logoutAEMUri);
    }
    const redirectUri = (0, redirect_1.getRedirectUrl)() || (envConfig === null || envConfig === void 0 ? void 0 : envConfig.homepageUri);
    yield (0, auth_1.redirectToLogout)(redirectUri);
  }
});
exports.signOut = signOut;
const handleLocalhost = env => {
  (0, redirect_1.setRedirectUrl)();
  const urlParams = new URLSearchParams(window.location.search);
  const action = urlParams.get('action');
  if (action && (env === 'deve' || env === 'qa')) {
    (0, localhost_1.handleLocalhostAction)(action, env);
    return;
  }
  const token = urlParams.get('token');
  (0, localhost_1.handleLocalhostToken)(token);
  const redirectUrl = (0, redirect_1.getRedirectUrl)();
  (0, redirect_1.removeRedirectUrl)();
  (0, redirect_2.makeRedirectTo)(redirectUrl || `${(0, localhost_1.getLocalhostBaseUrl)()}/#/`);
};
exports.handleLocalhost = handleLocalhost;
//# sourceMappingURL=index.js.map